import { Grid, IconButton, InputAdornment } from "@material-ui/core";
import { VisibilityOff, Visibility } from "@material-ui/icons";
import { useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import InputField from "src/components/ui-components/InputField";

type FormikContextType = {
	SMTPFromAddress: string | null;
	SMTPServerURL: string | null;
	SMTPServerPort: string | null;
	SMTPUsername: string | null;
	SMTPPassword: string | null;
};

const SMTPSettings: FC = () => {
	const [showSmtpPassword, setShowSmtpPassword] = useState<boolean>(false);
	const { values, setFieldValue } = useFormikContext<FormikContextType>();

	useEffect(() => {
    if (values.SMTPServerURL) {
      try {
        const url = new URL(values.SMTPServerURL);
        if (url.port) {
          setFieldValue("SMTPServerPort", url.port);

          const cleanUrl = `${url.protocol}//${url.hostname}`;
          setFieldValue("SMTPServerURL", cleanUrl);
        }
      } catch (error) {
        // Ignore invalid URLs
      }
    }
  }, [values.SMTPServerURL, setFieldValue]);

	return (
		<Grid container spacing={2}>
			<Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
				<InputField
      	  label="From *"
      	  name="SMTPFromAddress"
					value={values.SMTPFromAddress}
					onChange={(event) => setFieldValue('SMTPFromAddress', event?.target?.value || null)}
      	/>
			</Grid>
			<Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
				<InputField
      	  label="Server URL *"
      	  name="SMTPServerURL"
					value={values.SMTPServerURL}
					onChange={(event) => setFieldValue('SMTPServerURL', event?.target?.value || null)}
      	/>
			</Grid>
			<Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
				<InputField
      	  label="Port *"
      	  name="SMTPServerPort"
					value={values.SMTPServerPort}
					onChange={(event) => setFieldValue('SMTPServerPort', event?.target?.value ? Number(event.target.value) : null)}
      	/>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
				<InputField
					label="Username *"
					name="SMTPUsername"
					value={values.SMTPUsername}
					onChange={(event) => setFieldValue('SMTPUsername', event?.target?.value || null)}
				/>
			</Grid>
			<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
				<InputField
					label="Password *"
					name="SMTPPassword"
					type={showSmtpPassword ? "text" : "password"}
					value={values.SMTPPassword}
					onChange={(event) => setFieldValue('SMTPPassword', event?.target?.value || null)}
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									onClick={() => {
										setShowSmtpPassword((prev) => !prev);
									}}
								>
									{showSmtpPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
			</Grid>
		</Grid>
	);
};

export default SMTPSettings;